import { ref } from "vue";
import Api from "@/api";
import Cookies from "js-cookie";
import { Toast } from "@vant/compat";
import { triggerLogin } from "@/utils/triggerLogin";

export default function useVote() {
  const isVote = ref(false);
  const isVoted = ref(false);
  const submitData = ref({ items: [] });
  const isApp = navigator.userAgent.toLowerCase().indexOf("zsrbapp") >= 0;

  const isInAppOrWechat = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("micromessenger") >= 0 || ua.indexOf("zsrbapp") >= 0;
  };

  const checkElement = (selector, maxTries, tryInterval) => {
    let count = 0;
    const intervalId = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(intervalId);
        isVote.value = true;
        const sessionToken = sessionStorage.getItem("session_token");
        const token = Cookies.get("token");
        console.log("pppppppp投票功能", sessionToken, token);
        if (sessionToken || token) {
          console.log("获取投票详情");
          getVotesDetail();
        }
      } else if (count >= maxTries) {
        clearInterval(intervalId);
        isVote.value = true;
      } else {
        count++;
        isVote.value = false;
      }
    }, tryInterval);
  };

  const getSubmitData = (questions) => {
    if (!questions || questions.length === 0) return;
    const existingItems = submitData.value.items || [];
    const items = questions.map((item) => {
      const existing = existingItems.find((ei) => ei.question_id == item.id);
      return {
        question_id: item.id,
        option_ids: existing ? existing.option_ids : []
      };
    });
    submitData.value = { items };
  };

  const formatSubmitData = (type, elem) => {
    if (!submitData.value.items || submitData.value.items.length === 0) {
      const allOptions = document.querySelectorAll(
        ".vote_option_single, .vote_option_multi"
      );
      const questionIds = new Set();
      allOptions.forEach((opt) => {
        const qid = opt.getAttribute("data-question-id");
        if (qid) questionIds.add(qid);
      });
      const items = Array.from(questionIds).map((id) => ({
        question_id: Number(id),
        option_ids: []
      }));
      if (items.length === 0) return;
      submitData.value = { items };
    }

    let isSubmit = true;
    const question_id = elem.getAttribute("data-question-id");
    const option_id = elem.getAttribute("data-option-id");
    const _item = submitData.value.items.find(
      (_u) => _u.question_id == question_id
    );
    if (!_item) return;

    if (type === "single") {
      _item.option_ids = [Number(option_id)];
    } else if (type === "multi") {
      _item.option_ids = _item.option_ids.includes(Number(option_id))
        ? _item.option_ids.filter((_u) => _u != Number(option_id))
        : [..._item.option_ids, Number(option_id)];
    }

    submitData.value.items.forEach((item) => {
      if (item.option_ids.length == 0) {
        isSubmit = false;
      }
    });

    const btn = document.querySelector(".vote_item_button");
    if (btn) {
      isSubmit ? btn.classList.add("active") : btn.classList.remove("active");
    }
  };

  const siblingsRemove = (elem) => {
    formatSubmitData("single", elem);
    const parent = elem.parentNode;
    for (let i = 0; i < parent.childNodes.length; i++) {
      if (parent.childNodes[i] !== elem) {
        if (
          parent.childNodes[i].children &&
          parent.childNodes[i].children[0].classList
        ) {
          parent.childNodes[i].children[0].classList.remove("active");
        }
      }
    }
  };

  const changeVoteStyle = (questions) => {
    let singleItemArr = [];
    let multiItemArr = [];
    questions.forEach((item) => {
      if (item.mode == "single") {
        singleItemArr = singleItemArr.concat(item.options);
      } else if (item.mode == "multi") {
        multiItemArr = multiItemArr.concat(item.options);
      }
    });
    const singleItems = document.querySelectorAll(".vote_option_single");
    singleItems.forEach((item, index) => {
      const data = singleItemArr[index];
      if (data) {
        item.innerHTML = `<span class="vote-option-container" style="width: 100%;"> <span class="vote-option-content">${data.content}</span> <span class="vote-option-data" style="">  <span class="vote-option-progress">    <span class="curr-progress" style="width: ${data.percent}%;"></span>  </span>  <span class="vote-option-percent">${data.percent}%</span></span></span>`;
      }
    });
    const multiItems = document.querySelectorAll(".vote_option_multi");
    multiItems.forEach((item, index) => {
      const data = multiItemArr[index];
      if (data) {
        item.innerHTML = `<span class="vote-option-container" style="width: 100%;"> <span class="vote-option-content">${data.content}</span> <span class="vote-option-data" style="">  <span class="vote-option-progress">    <span class="curr-progress" style="width: ${data.percent}%;"></span>  </span>  <span class="vote-option-percent">${data.percent}%</span></span></span>`;
      }
    });
  };

  const getVotesDetail = () => {
    const voteBox = document.querySelector(".vote_box");
    if (voteBox) {
      document.querySelector(".edit_vote_btn").style.display = "none";
    }
    if (!voteBox) return;

    Api.getVotes({
      id: voteBox.getAttribute("data-vote-id")
    })
      .then((res) => {
        if (res?.code == 1) {
          const data = res?.data;
          if (!data.voted) {
            if (new Date().getTime() > Date.parse(data.end_time)) {
              changeVoteStyle(data.questions);
              const btn = document.querySelector(".vote_item_button");
              if (btn) btn.innerHTML = "投票已结束";
              isVoted.value = true;
            } else {
              getSubmitData(data.questions);
            }
          } else {
            isVoted.value = data.voted;
            changeVoteStyle(data.questions);
            const btn = document.querySelector(".vote_item_button");
            if (btn) btn.innerHTML = "你已投票";
          }
        }
      })
      .catch(() => {});
  };

  const handleVote = async () => {
    console.log(submitData.value);
    if (!isInAppOrWechat()) {
      Toast("请在APP环境或者微信环境中进行投票");
      return true;
    }

    const sessionToken = sessionStorage.getItem("session_token");
    if (!sessionToken && isApp) {
      const loggedIn = await triggerLogin();
      console.log("handleVoteloggedIn", loggedIn);
      // if (loggedIn) {
      //   getVotesDetail();
      // }
      return;
    }

    if (!submitData.value.items || submitData.value.items.length === 0) return;
    const voteBox = document.querySelector(".vote_box");
    if (!voteBox) return;

    Api.voting({
      id: voteBox.getAttribute("data-vote-id"),
      data: submitData.value
    }).then((data) => {
      console.log("voting", data);
      if (data?.code === 1) {
        Toast.success("投票成功");
        getVotesDetail();
      } else {
        console.log("投票失败", data);
        Toast(data?.message || "投票失败");
      }
    });
  };

  const handleVoteImageClick = (target) => {
    const parent = target.parentNode;
    const grandParent = parent && parent.parentNode;
    if (!grandParent) return false;

    if (grandParent.classList.contains("vote_option_single")) {
      grandParent.children[0].classList.add("active");
      siblingsRemove(grandParent);
      return true;
    }
    if (grandParent.classList.contains("vote_option_multi")) {
      grandParent.children[0].classList.toggle("active");
      formatSubmitData("multi", grandParent);
      return true;
    }
    return false;
  };

  const handleVoteItemClick = async (e) => {
    if (e.target.classList.contains("vote_option_single")) {
      if (isVoted.value) return true;
      e.target.children[0].classList.add("active");
      siblingsRemove(e.target);
      return true;
    }
    if (e.target.classList.contains("radio_item")) {
      e.target.classList.add("active");
      if (
        e.target.parentNode &&
        e.target.parentNode.classList.contains("vote_option_single")
      ) {
        siblingsRemove(e.target.parentNode);
      }
      return true;
    }
    if (e.target.classList.contains("vote_option_single_select")) {
      if (
        e.target.parentNode &&
        e.target.parentNode.classList.contains("vote_option_single")
      ) {
        e.target.parentNode.children[0].classList.add("active");
        siblingsRemove(e.target.parentNode);
      }
      return true;
    }

    if (e.target.classList.contains("vote_option_multi")) {
      if (isVoted.value) return true;
      e.target.children[0].classList.toggle("active");
      formatSubmitData("multi", e.target);
      return true;
    }
    if (e.target.classList.contains("checkbox_item")) {
      e.target.classList.toggle("active");
      formatSubmitData("multi", e.target.parentNode);
      return true;
    }
    if (e.target.classList.contains("vote_option_multi_select")) {
      if (
        e.target.parentNode &&
        e.target.parentNode.classList.contains("vote_option_multi")
      ) {
        e.target.parentNode.children[0].classList.toggle("active");
        formatSubmitData("multi", e.target.parentNode);
      }
      return true;
    }

    if (e.target.classList.contains("vote_item_button")) {
      // if (e.target.classList.contains("active")) {
      //   handleVote();
      // }
      handleVote();
      return true;
    }

    return false;
  };

  const initVote = () => {
    checkElement(".vote_box", 5, 1000);
  };

  return {
    isVote,
    isVoted,
    initVote,
    handleVoteImageClick,
    handleVoteItemClick,
    handleVote
  };
}
